import React, { useEffect, useState } from 'react';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

import { FlexColumn } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { RefundAssistSection } from './components/refund-assist-section';
import { RegisteredView } from './components/registered-view';
import { UnregisteredView } from './components/unregistered-view';
import messages from './messages';
import style from './style.module.less';
import { useGlobalModalLaunchContext } from '../../../../../../contexts/modal-context/global-modal-context';
import { emptyObject } from 'ui-components/default-props/empty';
import { PageEventSourceStrings } from '../../../../../../pages/settings/payment-and-subscription/hooks/use-track-event';
import { useWallet } from '../../../../../../wallet/hooks/use-wallet';
import { usePaymentAndSubscriptionMegaContext } from '../../../../../settings/payment-and-subscription/context';
import { useIsRefundAssistVisible } from '../../../../../../hooks/refund-assist/use-is-refund-assist-visible';
import { useFilteredTodoCards } from '../../../todo-cards/helpers/should-show-todo-card';
import { todoCardData } from '../../../todo-cards/todo-card-data';
import { todoPageIds } from '../../../todo-cards/todo-card-ids';
import { TodoCardsContainer } from '../../../todo-cards/todo-cards-container';

export const CarrierStep = ({ onRefundAssistSaveReady, onRefundAssistToggleChange }) => {
  const wallet = useWallet();
  const { isWalletRegistered = false, walletId } = wallet || emptyObject;
  const { openBillingInfoModal } = useGlobalModalLaunchContext();
  const [isRegistered, setIsRegistered] = useState(false);
  const { isBillingInfoLoading: isLoading } = usePaymentAndSubscriptionMegaContext();
  const isRefundAssistVisible = useIsRefundAssistVisible();

  useEffect(() => {
    setIsRegistered(isWalletRegistered);
  }, [isWalletRegistered]);

  const todoCards = useFilteredTodoCards(todoCardData, {
    pageWhereRendered: todoPageIds.CARRIERS_PAGE,
  });
  const handleEditClick = () => {
    if (walletId) {
      openBillingInfoModal({
        trackingSourceString: PageEventSourceStrings.FTU_WIZARD,
        transactionCategory: TransactionCategory.AddFunds,
      });
    }
  };
  const LoadingState = () => {
    return (
      <FlexColumn className={style['loading-container']}>
        <LoadingIndicator size='large' />
      </FlexColumn>
    );
  };

  return (
    <>
      <FlexColumn className={style['carriers-step-header']}>
        <Text className={style.header} textType={TextType.H2} value={messages.ftuCarriersStepTitle} />
        <Text textType={TextType.Description} value={messages.ftuCarriersStepDescription} />
      </FlexColumn>

      {isLoading && <LoadingState />}

      {!isLoading && (
        <>
          {isRegistered ? (
            <>
              <RegisteredView onEditClick={handleEditClick} />
              {isRefundAssistVisible && (
                <RefundAssistSection onSaveFunctionReady={onRefundAssistSaveReady} onToggleChange={onRefundAssistToggleChange} />
              )}
            </>
          ) : (
            <UnregisteredView />
          )}
          <div className={style['todo-cards-wrapper']}>
            <TodoCardsContainer todoCards={todoCards} />
          </div>
        </>
      )}
    </>
  );
};
